import React, {useEffect} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/svg/group42.svg"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { AppDataContext } from '../../../contexts/app-data';
import getStep from '../../../helpers/getStep';

const PageBus = window.PageBus


const IntroStep = () => {
    const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)

useEffect(() => {
        if (PageBus) {
        PageBus.publish("analyticsServices",{
    pageID: "onboarding",
    stepSeq: "0",
    stepName: "welcome:get to know you",
    flowType: "sales",
    flowName: "onboarding",
    productName: "onboarding",
    trackMethod: "flow"
        });
    };

    getStep(["transaction_id"]).then(
        res =>
            window.digitalData.onlineSalesAndServiceFlows.transactionID = res["transaction_id"] !== "NULL" ? res["transaction_id"] : "" 
        )
    }, [])
    return (
        <div className={"intro-step"}>
            {/* <StepsWrapper stepGroupTitle={t('general.open_pro_account')} loaded={0.1} title={t('general.open_pro_account')}> */}
            <StepsWrapper stepGroupTitle={t('general.open_pro_account')} loaded={0.1}>
                <StepsLoader>

                    <BaseParagraph  illustration={illustration} />
                    <BaseParagraph  align={"center"} >
                        <h3>{t('Welcome_get_to_know_you.title')}</h3>
                        <p>{t('Welcome_get_to_know_you.text')}</p>
                    </BaseParagraph>

                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} link={`/${lang.toLowerCase()}/steps/identity`}/>
                    </div>
                </StepsLoader>
            </StepsWrapper>
        </div>

    )
}

IntroStep.propTypes = {
    name: PropTypes.string
}

IntroStep.defaultProps = {
    name: "Step02"
}


export default IntroStep